export const NOTIFICATION_TEMPLATES_LOADING = "NOTIFICATION_TEMPLATES_LOADING";
export const NOTIFICATION_TEMPLATES_ERROR = "NOTIFICATION_TEMPLATES_ERROR";

export const NOTIFICATION_TEMPLATES_GET_LIST = "NOTIFICATION_TEMPLATES_GET_LIST";
export const NOTIFICATION_TEMPLATES_CREATE = "NOTIFICATION_TEMPLATES_CREATE";
export const NOTIFICATION_TEMPLATES_DELETE = "NOTIFICATION_TEMPLATES_DELETE";



// WEBPACK FOOTER //
// ./src/actions/notificationTemplates/constants.js